import { render, staticRenderFns } from "./LoginOld.vue?vue&type=template&id=342d0cf1&"
import script from "./LoginOld.vue?vue&type=script&lang=js&"
export * from "./LoginOld.vue?vue&type=script&lang=js&"
import style0 from "./LoginOld.vue?vue&type=style&index=0&id=342d0cf1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports